const secondaryColors = {
  SECONDARY_20: '#FFFEF4',
  SECONDARY_50: '#FFFCE7',
  SECONDARY_100: '#FFF8C5',
  SECONDARY_200: '#FFF39E',
  SECONDARY_300: '#FFEE79',
  SECONDARY_400: '#FFE85B',
  SECONDARY_500: '#FFE33E',
  SECONDARY_600: '#FFD43E',
  SECONDARY_700: '#FFBC38',
  SECONDARY_800: '#FCA532',
  SECONDARY_900: '#F67D28',
}

export default secondaryColors
